import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getCardsLanguages } from '../services/FamilyCardsService'
import useNotifications from './useNotifications'

export default function useCardsLanguages() {
  const [languages, setLanguages] = useState([
    {
      code: 'en',
      name: 'English',
      supported: true,
    },
  ])
  const { t } = useTranslation()
  const { error } = useNotifications()
  useEffect(() => {
    getCardsLanguages()
      .then((response) => {
        setLanguages(
          response.data
            .filter((lang) => lang.supported)
            .map((lang) => {
              lang.name = t(`languages.${lang.code}`, lang.name)
              return lang
            })
            .sort((a, b) => a.name.localeCompare(b.name))
        )
      })
      .catch((err) => {
        error(
          t(
            'familyCards.getFamilyCardLanguages.error',
            `Error getting supported languages for family cards: {message}`,
            { message: err.message || '' }
          ),
          err
        )
      })
  }, [error, setLanguages, t])

  return { languages }
}
